import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {AbstractService, AppConfigService, LoggedUserService, SearchDataProvider} from '../../bonding_shared/services';
import {
  BusinessObjectDto,
  DictionaryBaseDto,
  Page,
  ServiceNoteCriteriaDto,
  ServiceNoteDto,
} from '../../bonding_shared/model';
import {ActivatedRoute} from '@angular/router';

@Injectable()
export class ServiceNoteService extends AbstractService {
  protected url = this.urlPrefix + 'serviceNote';
  dataProvider: SearchDataProvider<ServiceNoteCriteriaDto, ServiceNoteDto>;
  pageSize = 10;
  page = 1;
  constructor(
    public http: HttpClient,
    appConfigService: AppConfigService,
    loggedUserService: LoggedUserService,
    private activatedRoute: ActivatedRoute
  ) {
    super(http, appConfigService, loggedUserService);
    this.dataProvider = new SearchDataProvider<ServiceNoteCriteriaDto, ServiceNoteDto>(this);
  }

  createServiceNote(contact: ServiceNoteDto): Observable<ServiceNoteDto> {
    console.log('crete contact note:' + JSON.stringify(contact));
    return this.put<ServiceNoteDto>(contact, this.url);
  }
  private counts = new BehaviorSubject<{[key: string]: number}>({});
  counts$ = this.counts.asObservable();

  setCount(total: number, tab?: any) {
    const current = this.counts.getValue();
    this.counts.next({...current, [tab]: total});
  }

  getNotesList(_businessObjectType: number, _businessObjectId: number) {
    this.setupCriteria(_businessObjectId, _businessObjectType);
    this.dataProvider.search(this.getPage()).subscribe((res) => {
      this.setCount(res.size, _businessObjectId);
    });
  }

  getPage(): Page {
    const page = <Page>{};
    page.count = this.pageSize;
    page.start = (this.page - 1) * this.pageSize;
    return page;
  }

  setupCriteria(_businessObjectId: number, _businessObjectType: number) {
    this.criteria = <ServiceNoteCriteriaDto>{};
    this.criteria.businessObject = <BusinessObjectDto>{};
    this.criteria.businessObject.relatedToId = _businessObjectId;
    this.criteria.businessObject.relatedTo = <DictionaryBaseDto>{};
    this.criteria.businessObject.relatedTo.id = _businessObjectType;
  }

  get criteria(): ServiceNoteCriteriaDto {
    return this.dataProvider.searchCriteria.criteria;
  }

  set criteria(c: ServiceNoteCriteriaDto) {
    this.dataProvider.searchCriteria.criteria = c;
  }
}
